import { Outlet, useNavigate } from 'react-router-dom';
import UserIcon from "src/assets/all-icons/user-icon.jsx";

import AuthService from '@/services/auth.service';
import SuarteName from '@/shared-components/icons/components/public/SuarteName';
import Text from '@/shared-components/text/components/Text';

import './styles/AdminHeader.css';

export default function AdminHeader() {
  const navigate = useNavigate();

  return (
    <>
      <div className="admin-header__navbar">
        <SuarteName className="admin-header__suarte-name" onClick={()=>navigate("/admin")}/>
        <div>
          <button 
            className={`app-navigation__nav-option profile ${location.pathname.includes("/profile") ? "active" : ""}`} 
            aria-label="Profile"
            onClick={() => navigate("/admin/change-password")}
          >
            <UserIcon/>
          </button>
          <button className="admin-header__logout" onClick={AuthService.logout}><Text className="admin-header__logout-text font-size-large">Cerrar sesion</Text></button>
        </div>
      </div>
      <Outlet/>
    </>
  );
}
